import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconChecklist } from "@tabler/icons-react";
import { DatosServiciosAutorizacionDef } from "./DatosServiciosAutorizacionDef";

export const DatosServiciosIcon = IconChecklist;
export const DatosServiciosHelpText = '* Datos Servicios Autorización';

export class DatosServiciosAutorizacion extends Entity<DatosServiciosAutorizacionDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new DatosServiciosAutorizacionDef(), parentKeys);
        this.Form = import('./DatosServiciosAutorizacionForm').then((module) => module.DatosServiciosAutorizacionForm);
        this.Title = "Autorización de Reportes";
        this.HelpText = DatosServiciosHelpText;
        this.Icon = DatosServiciosIcon;
    }
}